//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vModal from '@/core/vModal'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'TicketInfoModal',
  extends: vModal,
  data () {
    return {
      fields: [
        { id: 'pc_name', label: '商品名稱' },
        { id: 'ex_name', label: '兌換規則' },
        { id: 'e_date', label: '兌換期限' }
      ],
      rows: [],
      inputValue: 1
    }
  },
  computed: {
    ...mapGetters([
      'site',
      'theme',
      'stock_no',
      'dateFormat'
    ])
  },
  created () {
    this.initData()
  },
  mounted () {
  },
  methods: {
    initData () {
    },
    dataReady () {
      // 傳進來是array資料
      this.rows = this.modalData
    },
    async clickUse () {
      if (this.inputValue < 0) {
        this.alert('請重新輸入張數')
        return
      }
      if (this.inputValue > this.rows.length) {
        this.alert(`輸入超過${this.rows.length}張，請重新輸入張數`)
        return
      }
      const cpnNo = []
      for (let i = 0; i < this.inputValue; i++) {
        cpnNo.push(this.rows[i].cpn_no)
      }
      const data = {
        ID_NO: this.params.id_no,
        text: this.stock_no,
        cpnNo: cpnNo.join(',')
      }
      const response = await this.fetch('ticketUse', this.site, data)
      if (response.result === 'OK') {
        this.alert('兌換成功')
        this.emit('TicketInfo.Used', 'success')
      } else {
        this.alert('兌換失敗')
        this.emit('TicketInfo.Close', 'fail')
      }
    },
    alert (message, callback = null) {
      this.$q.dialog({
        // title,
        message
      }).onOk(() => {
        this.isShowCheckModal = false
        if (callback !== null) callback()
      })
    },
    formatDate (str) {
      return moment(str).format(this.dateFormat)
    }
  }
}
